import { gql, useApolloClient } from "@apollo/client";

const IsProductInCustomAssortmentQuery = gql`
  query IsProductInCustomAssortment($productSku: String!, $clientId: ID!) {
    isProductInCustomAssortment(clientId: $clientId, productSku: $productSku)
  }
`;

const useIsProductInCustomAssortment = () => {
  const apollo = useApolloClient();

  const isProductInCustomAssortment = async ({ productSku, clientId }) => {
    const result = await apollo.query({
      query: IsProductInCustomAssortmentQuery,
      variables: { productSku, clientId },
      fetchPolicy: "network-only",
    });

    return result?.data?.isProductInCustomAssortment;
  };

  return {
    isProductInCustomAssortment,
  };
};

export default useIsProductInCustomAssortment;
